import React from "react";
import { connect, useDispatch } from "react-redux";
import { Button, message, Tooltip } from "antd";
import { FaMoon } from "react-icons/fa";
import axios from "axios";
import { DEFAULT_FONT, URL_API_CREATE_CUSTOM_MOON_PHASE, XKEY_API_CREATE_CUSTOM_MOON_PHASE } from "../../../../../config";
import { get, pick, random } from "lodash";
import { initNewLayer, uniqueID } from "../../../Utilities/helper";
import { ARTWORK } from "../../../../../types";
const AddMoonPhaseLayer = (props) => {
    const { layers } = props;
    const dispatch = useDispatch();

    const addMoonPhaseLayer = async () => {
        const key = "addLayerMoonPhase";
        message.loading({
            content: "Retrieving the current date...",
            key,
            duration: 0,
        });
        const today = new Date();
        const day = String(today.getDate()).padStart(2, "0");
        const month = String(today.getMonth() + 1).padStart(2, "0");
        const year = today.getFullYear();
        const date = `${year}-${month}-${day}`;

        message.loading({
            content: "Creating image...",
            key,
            duration: 0,
        });

        const bodyMoonPhase = {
            date,              // BẮT BUỘC
            "time": null,
            "location": null,               // {latitude, longitude}
            "reference_type": 'anniversary',
            "timezone": 'America/New_York',
            "render": {
                "style": "photoreal",
                "moon_color": "#ffdfb3",   // "#ffffff" nếu style=photoreal
                "width": 2000,
                "height": 2000,
                "orientation": "auto",
            }
        }
        const req = await axios.post(URL_API_CREATE_CUSTOM_MOON_PHASE, bodyMoonPhase, {
            headers: {
                'X-ABN-KEY': XKEY_API_CREATE_CUSTOM_MOON_PHASE,
                'content-type': 'application/json'
            }
        }).then(res => {
            return get(res, 'data.render', false);
        }).catch(() => {
            return false;
        });


        if (!req){
            message.error({
                content: "Created new Moon Phase Class failure!",
                key,
                duration: 4,
            });
            return;
        }
        const moonPhase_ParentID = `moonPhaseId${uniqueID()}`
        const countMoonPhaseLayer = layers.filter((l) => l.imageMoonPhase).length + 1;
        const newImageLayer = initNewLayer();
        newImageLayer.type = "Image";
        newImageLayer.values[0].file = pick({
            id: uniqueID(),
            key: req.png_file.replace(/^\//, '')
        }, ["id", "key"]);
        newImageLayer.imageMoonPhase = true;
        newImageLayer.personalized = {
            enable: true,
        };
        newImageLayer.isDisplaySelectTime = false;
        newImageLayer.isDisplaySearchLocation = true;
        newImageLayer.title = `Image Moon Phase  #${countMoonPhaseLayer}`;
        newImageLayer.configsMoonPhase = { ...bodyMoonPhase };
        newImageLayer.moonPhase_ParentID = moonPhase_ParentID;
        const moonColorId = uniqueID();
        newImageLayer.MoonColors = [
            { id: moonColorId, color: bodyMoonPhase.render.moon_color, layerIds: [] }
        ]
        newImageLayer.activeMoonColorId = moonColorId;
        dispatch({
            type: ARTWORK.ADD_LAYER,
            payload: newImageLayer,
        });


        // date Text layer
        const newTextDate = initNewLayer();
        newTextDate.type = "Text";
        newTextDate.fontSize = 30;
        newTextDate.letterSpacing = 1;
        newTextDate.lineHeight = 1;
        newTextDate.x = random(10, 100);
        newTextDate.y = random(10, 100);
        newTextDate.align = "left";
        newTextDate.width = 160;
        newTextDate.values[0].text = "Your Text Moon Phase Date";
        newTextDate.fillAfterStrokeEnabled = true;
        newTextDate.fontFamily = DEFAULT_FONT;
        newTextDate.fill = "#000";
        newTextDate.autofit = true;
        newTextDate.moonPhase_ChildID = moonPhase_ParentID;
        newTextDate.textMoonPhaseDate = true;
        newTextDate.personalized = {
            enable: true
        };
        newTextDate.title = `Text Moon Phase Date #${countMoonPhaseLayer}`;
        dispatch({
            type: ARTWORK.ADD_LAYER,
            payload: newTextDate,
        });

        //Address Text layer
        const newTextAddress = initNewLayer();
        newTextAddress.type = "Text";
        newTextAddress.fontSize = 30;
        newTextAddress.letterSpacing = 1;
        newTextAddress.lineHeight = 1;
        newTextAddress.x = random(10, 100);
        newTextAddress.y = random(10, 100);
        newTextAddress.align = "left";
        newTextAddress.width = 160;
        newTextAddress.values[0].text = "Your Text Moon Phase Address";
        newTextAddress.fillAfterStrokeEnabled = true;
        newTextAddress.fontFamily = DEFAULT_FONT;
        newTextAddress.fill = "#000";
        newTextAddress.autofit = true;
        newTextAddress.moonPhase_ChildID = moonPhase_ParentID;
        newTextAddress.textMoonPhaseAddress = true;
        newTextAddress.personalized = {
            enable: true
        };
        newTextAddress.title = `Text Moon Phase Address #${countMoonPhaseLayer}`;
        dispatch({
            type: ARTWORK.ADD_LAYER,
            payload: newTextAddress,
        });

        //Coordinates Text layer
        const newTextCoordinates = initNewLayer();
        newTextCoordinates.type = "Text";
        newTextCoordinates.fontSize = 30;
        newTextCoordinates.letterSpacing = 1;
        newTextCoordinates.lineHeight = 1;
        newTextCoordinates.x = random(10, 100);
        newTextCoordinates.y = random(10, 100);
        newTextCoordinates.align = "left";
        newTextCoordinates.width = 160;
        newTextCoordinates.values[0].text = "Your Text Moon Phase Coordinates";
        newTextCoordinates.fillAfterStrokeEnabled = true;
        newTextCoordinates.fontFamily = DEFAULT_FONT;
        newTextCoordinates.fill = "#000";
        newTextCoordinates.autofit = true;
        newTextCoordinates.moonPhase_ChildID = moonPhase_ParentID;
        newTextCoordinates.textMoonPhaseCoordinates = true;
        newTextCoordinates.personalized = {
            enable: true
        };
        newTextCoordinates.title = `Text Moon Phase Coordinates #${countMoonPhaseLayer}`;
        dispatch({
            type: ARTWORK.ADD_LAYER,
            payload: newTextCoordinates,
        });



        message.success({
            content: "Successfully created new Moon Phase Layer!",
            key,
            duration: 4,
        });
    }
    return <>
    
        <Tooltip title="Add Image Moon Phase" placement="topRight">
            <Button
                onClick={addMoonPhaseLayer}
                style={{
                    width: "100%",
                    borderRadius: 0,
                    borderLeftWidth: 0,
                    padding: 0,
                }}
                icon={<FaMoon className="anticon" />}
            ></Button>
        </Tooltip></>
}

export default connect((state) => ({
  workspace: state.artwork.workspace,
}))(AddMoonPhaseLayer);